// Example: src/App.js
import React , { useState, useContext,useEffect }from 'react';
import { AuthProvider ,AuthConsumer} from 'react-oauth2-code-pkce';
import AppRoutes from './AppRoutes'; // Your main routes
import { AuthContext } from "react-oauth2-code-pkce"; // ✅ import context
import { authConfig } from './authConfig';

/*export const authConfig = {
  clientId: 'react-app',
  authorizationEndpoint: 'https://31.97.206.87:8443/realms/family-dunia/protocol/openid-connect/auth',
  logoutEndpoint: 'https://31.97.206.87:8443/realms/family-dunia/protocol/openid-connect/logout',
  tokenEndpoint: 'https://31.97.206.87:8443/realms/family-dunia/protocol/openid-connect/token',
  redirectUri: 'http://localhost:3000',
  scope: 'profile openid',
  decodeToken: true,
  autoLogin: false,
  pkce: true
};*/

function AppLoader() {
  const { authService } = useContext(AuthContext);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Initialize auth state
    const init = async () => {
      try {
        // This will restore any existing session if token exists
        await authService.handleRedirectCallback(); 
      } catch (e) {
        // Ignore if no redirect
      } finally {
        setIsReady(true);
      }
    };

    init();
  }, [authService]);

  if (!isReady) {
    return <div>Loading authentication...</div>;
  }

  return <AppRoutes />;
}

function App() {
  return (
    <AuthProvider authConfig={authConfig}>
       <AppLoader />
    </AuthProvider>
  );
}

export default App;
